import { render, staticRenderFns } from "./studentAlbum.vue?vue&type=template&id=11fde2a7&scoped=true&"
import script from "./studentAlbum.vue?vue&type=script&lang=js&"
export * from "./studentAlbum.vue?vue&type=script&lang=js&"
import style0 from "./studentAlbum.vue?vue&type=style&index=0&id=11fde2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fde2a7",
  null
  
)

export default component.exports